import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PublicRoute from './PublicRoute';
import ProtectedRoute from './ProtectedRoute';
import StagingPasswordRoute from './StagingPasswordRoute';
import Auth from '../../features/auth/components/Auth';
import EnrollmentWelcome from '../../features/enrollment/components/EnrollmentWelcome';
import StatusProtectedRoute from './StatusProtectedRoute';
import StatusRouter from './components/StatusRouter';
import { BYPASS_REDIRECT_PATHS } from './types';
import MindRightEnrollment from '../../features/enrollment/components/MindRightEnrollment';
import ApplicationReceived from '../../features/enrollment/components/ApplicationReceived';
import CheckoutPage from '../../features/payment/components/CheckoutPage';
import SuccessPage from '../../features/payment/components/SuccessPage';
import AccountSettings from '../../features/accounts/components/AccountSettings';
import Subscriptions from '../../features/payment/components/Subscriptions';
import { EnrollmentStatus } from '../../core/constant/constant';
import Support from '../../features/support/Support';
import MindRightEnrollment2 from '../../features/enrollment/components/MindRightEnrollment2';
import Dashboard from '../../features/dashboard/components/Dashboard';
import BillingLayout from '../../features/billing/BillingLayout';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route element={<StagingPasswordRoute />}>
        <Route path='/success' element={<SuccessPage />} />
        <Route element={<PublicRoute />}>
          <Route path='/auth' element={<Auth />} />
        </Route>
      </Route>

      <Route
        path='/home'
        element={
          <StatusProtectedRoute
            allowedStatuses={[
              EnrollmentStatus.FULLY_ENROLLED_ACTIVE,
              EnrollmentStatus.ENROLLMENT_COMPLETE_NO_PAYMENT,
            ]}
          >
            <Dashboard />
          </StatusProtectedRoute>
        }
      />

      <Route
        path='/enrollment-welcome'
        element={
          <StatusProtectedRoute
            allowedStatuses={[EnrollmentStatus.FIRST_TIME_LOGIN, EnrollmentStatus.SIGNED_UP]}
          >
            <EnrollmentWelcome />
          </StatusProtectedRoute>
        }
      />

      <Route
        path='/enrollment'
        element={
          <StatusProtectedRoute
            allowedStatuses={[
              EnrollmentStatus.FIRST_TIME_LOGIN,
              EnrollmentStatus.SIGNED_UP,
              EnrollmentStatus.INCOMPLETE_ENROLLMENT,
            ]}
          >
            <MindRightEnrollment />
          </StatusProtectedRoute>
        }
      />
      <Route
        path='/addition-information'
        element={
          <StatusProtectedRoute
            allowedStatuses={[
              EnrollmentStatus.FIRST_TIME_LOGIN,
              EnrollmentStatus.SIGNED_UP,
              EnrollmentStatus.INCOMPLETE_ENROLLMENT,
              EnrollmentStatus.ADDITIONAL_INFORMATION,
              EnrollmentStatus.PENDING_MATCHING,
            ]}
          >
            <MindRightEnrollment2 />
          </StatusProtectedRoute>
        }
      />
      <Route
        path='/application-received'
        element={
          <StatusProtectedRoute
            allowedStatuses={[
              EnrollmentStatus.WAITLIST_ELIGIBILITY_REVIEW,
              EnrollmentStatus.PENDING_MATCHING,
              EnrollmentStatus.INCOMPLETE_ENROLLMENT,
            ]}
          >
            <ApplicationReceived />
          </StatusProtectedRoute>
        }
      />

      <Route
        path='/checkout'
        element={
          <StatusProtectedRoute
            allowedStatuses={[
              EnrollmentStatus.FIRST_TIME_LOGIN,
              EnrollmentStatus.PENDING_MATCHING,
              EnrollmentStatus.INCOMPLETE_ENROLLMENT,
            ]}
          >
            <CheckoutPage />
          </StatusProtectedRoute>
        }
      />

      <Route
        path='/subscriptions'
        element={
          <StatusProtectedRoute
            allowedStatuses={[
              EnrollmentStatus.FIRST_TIME_LOGIN,
              EnrollmentStatus.PENDING_MATCHING,
              EnrollmentStatus.ENROLLMENT_COMPLETE_NO_PAYMENT,
            ]}
          >
            <Subscriptions />
          </StatusProtectedRoute>
        }
      />

      <Route
        path='/account-settings'
        element={
          <StatusProtectedRoute
            allowedStatuses={[EnrollmentStatus.FULLY_ENROLLED_ACTIVE]}
            bypassPaths={[...BYPASS_REDIRECT_PATHS, '/account-settings']}
          >
            <AccountSettings />
          </StatusProtectedRoute>
        }
      />
      <Route
        path='/billing'
        element={
          <StatusProtectedRoute
            allowedStatuses={[EnrollmentStatus.FULLY_ENROLLED_ACTIVE]}
            bypassPaths={[...BYPASS_REDIRECT_PATHS, '/billing']}
          >
            <BillingLayout />
          </StatusProtectedRoute>
        }
      />
      <Route
        path='/support'
        element={
          <StatusProtectedRoute
            allowedStatuses={[EnrollmentStatus.FULLY_ENROLLED_ACTIVE]}
            bypassPaths={[...BYPASS_REDIRECT_PATHS, '/support']}
          >
            <Support />
          </StatusProtectedRoute>
        }
      />
      <Route
        path='/'
        element={
          <ProtectedRoute>
            <StatusRouter allowedStatuses={[]} requireExactMatch={false}>
              <div />
            </StatusRouter>
          </ProtectedRoute>
        }
      />
      <Route path='*' element={<div>Not Found</div>} />
    </Routes>
  );
};

export default AppRoutes;
